import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import carouselStyle from "assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.js";

import image1 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0027.jpg"
import image2 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0028.jpg"
import image3 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0029.jpg"
import image4 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0030.jpg"
import image5 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0031.jpg"
import image6 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0032.jpg"
import image7 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0033.jpg"
import image8 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0034.jpg"
import image9 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0036.jpg"
import image10 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0037.jpg"
import image11 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0038.jpg"
import image12 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0040.jpg"
import image13 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0049.jpg"
import image14 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0050.jpg"
import image15 from "assets/img/gallery/travellerClick/travelClick1/IMG-20210326-WA0052.jpg"

const useStyles = makeStyles(carouselStyle);

export default function TravelCarousel() {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <div className={classes.section} id="carousel">
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} md={12} className={classes.marginAuto}>
            <Card>
              <Carousel {...settings}>
                <div>
                  <img src={image1} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image2} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image3} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image4} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image5} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image6} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image7} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image8} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image9} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image10} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image11} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image12} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image13} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image14} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image15} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Traveller’s Click
                    </h4>
                  </div>
                </div>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
